<div class="tab-pane" role="tabpanel" id="revisor">
    <fieldset id="agregar_revisor" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n del Revisor</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar Revisor</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_ind" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">

                                <form [formGroup]="rut_ind">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_ind" name="rut_ind" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_ind && rut_ind.controls?.rut.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                        <mat-error *ngIf="rut_ind && rut_ind.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </form>

                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_ind" [disabled]="!rut_ind.valid" (click)="get_revisor(rut_ind.controls.rut.value)">
                                            Agregar revisor
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--Detalle de los revisors-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span> {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_revisor(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_revisor(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del revisor</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del revisor</strong>, su solicitud pasar&aacute; por un proceso de verificaci&oacute;n del revisor ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md" [(ngModel)]="revisor.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre_revisor">Nombre o Raz&oacute;n Social(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre_revisor" name="nombre_revisor" type="text" placeholder="Nombre o Raz&oacute;n Social" [(ngModel)]="revisor.nombre" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div id="hide-ind-enterprise">
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelpat_revisor">Apellido Paterno</label>
                        <div class="col-md-6">
                            <input id="apelpat_revisor" name="apelpat_revisor" type="text" placeholder="Apellido Paterno" [(ngModel)]="revisor.apellido_pat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apelmat_revisor">Apellido Materno</label>
                        <div class="col-md-6">
                            <input id="apelmat_revisor" name="apelmat_revisor" type="text" placeholder="Apellido Materno" [(ngModel)]="revisor.apellido_mat" class="form-control input-md">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_calle_revisor">Direcci&oacute;n Calle(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_calle_revisor" name="dir_calle_revisor" type="text" placeholder="Calle" [(ngModel)]="revisor.direccion" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_revisor">Direcci&oacute;n Numero(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_num_revisor" name="dir_num_revisor" type="text" placeholder="Numero" [(ngModel)]="revisor.direccion_num" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_comp_revisor">Direcci&oacute;n Complemento</label>
                        <div class="col-md-3">
                            <input id="dir_comp_revisor" name="dir_comp_revisor" type="text" placeholder="Complemento" [(ngModel)]="revisor.direccion_complemento" class="form-control input-md">
                        </div>
                        <div class="col-md-5">
                            <label class="col-md-5 control-label" for="comuna">Comuna(<span style="color: red">*</span>) </label>
                            <div class="col-md-7">
                                <mat-form-field class="example-full-width">
                                    <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="revisor.comuna">
                                    <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_revisor">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono_revisor" name="fono_revisor" type="text" placeholder="Tel&eacute;fono" [(ngModel)]="revisor.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_revisor">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_revisor" name="email_revisor" type="email" placeholder="mail@ejemplo.com" [(ngModel)]="revisor.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="patente_revisor">Patente</label>
                    <div class="col-md-6">
                        <input id="patente_revisor" name="patente_revisor" type="text" placeholder="patente" [(ngModel)]="revisor.patente" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="categoria_revisor">Categoria(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="categoria_revisor" name="categoria_revisor" type="text" placeholder="categoria" [(ngModel)]="revisor.categoria" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="registro_revisor">Registro(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="registro_revisor" name="registro_revisor" type="text" placeholder="registro" [(ngModel)]="revisor.registro" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_revisor" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_revisor" (click)="saverevisor() " [disabled]="!revisor.rut || !revisor.nombre || !revisor.mail || !revisor.categoria || !revisor.registro">Ingresar Revisor <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato del revisor.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>
    
<div class="separator"></div>